import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/core";
import ReactToPrint from "react-to-print";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";

import PrintIcon from "./PrintIcon";
import { formatDate } from "../../utils/date";
import images from "../../assets/img/images";

const styles = {
  container: {
    height: "100%",
    "@media print": {},
  },
  childrenContainer: {
    "@media print": {},
  },
};

const PrintContainer = (props) => {
  const { classes } = props;
  const printRef = React.useRef();

  return (
    <>
      <ReactToPrint
        trigger={() => <PrintIcon />}
        content={() => printRef.current}
      />
      <Box style={{ display: "none" }}>
        <Grid
          container
          direction="column"
          wrap="nowrap"
          ref={printRef}
          className={classes.container}
        >
          <Grid item xs className={classes.childrenContainer}>
            {props.children}
          </Grid>
          <Grid item style={{ paddingTop: "10px" }}>
            <Grid container alignItems="flex-end">
              <Grid item xs>
                {formatDate(new Date())}
              </Grid>
              <Grid item>
                <Grid container alignItems="center">
                  <Grid
                    item
                    className="flexCenter text-54"
                    style={{ marginRight: "10px" }}
                  >
                    {I18n.get("footer_poweredBy")}
                  </Grid>
                  <Grid item className="flexCenter">
                    <img
                      src={images.nuvoolaLogo}
                      style={{ width: "3cm" }}
                      alt="nuvoola_logo"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default withStyles(styles)(PrintContainer);
